import React from 'react';

//Material UI
import { Paper, Typography, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';

//Components
import Dropdown from '../../components/inputs/dropdown';
import Searchbox from '../../components/inputs/searchbox';
import AutocompleteBolean from '../../components/inputs/autocompletes/autocompleteBolean';
import AutocompleteChannels from '../../components/inputs/autocompletes/autocompleteChannels';
import AutocompleteBranches from '../../components/inputs/autocompletes/AutocompleteBranches';
import AutocompleteOrderStates from '../../components/inputs/autocompletes/AutocompleteOrderStates';
import AutocompleteSubChannels from '../../components/inputs/autocompletes/autocompleteSubChannels';
import AutocompletePaymentMethods from '../../components/inputs/autocompletes/AutocompletePaymentMethods';
import AutocompleteCards from '../../components/inputs/autocompletes/AutocompleteCards';
import { WrapperDatePicker } from '../../components/wrapperDatapicker';

// Hooks
import useStyles from './styles';
import useUser from '../../hooks/user/useUser';
// Models
import { FilterdocumentTypes } from '../../models/EnumEntity';
// Utils
import { utils } from '../../utils/utils';

const OrderFilters = ({ filters, setFilters, clearFilters, franchiseSearch, handleSearch }) => {
    const { classes } = useStyles();
    const { business } = useUser();

    const handleFilterChange = (event) =>
        setFilters({
            ...filters,
            [event.target.name]: event.target.value,
            pageNumber: 1
        });

    const handleAutocompleteCardsChange = (e, o, name, value) => {
        setFilters({ [name]: value, pageNumber: 1 })
    }
    const handleAutoCompleteChange = (event, option, name) => {
        setFilters({
            ...filters,
            pageNumber: 1,
            [name]: option?.value
        });
    }

    const handleChannelChange = (event, option) => {
        setFilters(state => ({
            ...state,
            pageNumber: 1,
            channel: option?.value,
            subChannel: null,
            isFromApp: null
        }));
    }

    const handleSubChannelChange = (event, option, name) => {
        const filters = {
            pageNumber: 1,
            [name]: option?.value,
            isFromApp: null
        }

        setFilters(state => ({ ...state, ...filters }));
    }

    const handleStateAutocompleteChange = (event, options) => {
        const states = [...new Set(options.map(s => s.value))]
        setFilters({ ...filters, states, pageNumber: 1 });
    }

    const handleBranchAutocompleteChange = (event, options) => {
        const branchCodes = [...new Set(options.map(s => s.code))]
        setFilters({ ...filters, branchCodes, pageNumber: 1 });
    }

    const validateFilters = () =>
        !(utils.validateStringNullOrEmpty(filters?.billingCode) &&
            utils.validateStringNullOrEmpty(filters?.invoiceNumber) &&
            utils.validateStringNullOrEmpty(filters?.documentNumber))

    return (
        <Paper className={classes.paper}>
            <Grid container spacing={1}>
                {!franchiseSearch &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 4
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant='inherit' color='primary'> Filtrar por canal: </Typography>
                            </Grid>
                            <Grid size={6}>
                                <AutocompleteChannels
                                    size="small"
                                    isFranchise={business.isFranchise}
                                    onChange={handleChannelChange}
                                    value={filters?.channel || ""}
                                />
                            </Grid>
                            <Grid size={6}>
                                <AutocompleteSubChannels
                                    size="small"
                                    onChange={handleSubChannelChange}
                                    value={filters?.subChannel || ""}
                                    channel={business.isFranchise ? 'Tienda' : filters?.channel}
                                />
                            </Grid>
                        </Grid>
                    </Grid>}
                {!franchiseSearch &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 2
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant='inherit' color='primary'> Filtrar por vendedor: </Typography>
                            </Grid>
                            <Grid size={12}>
                                <Searchbox
                                    fullWidth
                                    size='small'
                                    name='sellerCode'
                                    label='Código'
                                    onChange={handleFilterChange}
                                    className={classes.searchbox}
                                    value={filters?.sellerCode || ""}
                                />
                            </Grid>
                        </Grid>
                    </Grid>}
                <Grid
                    size={{
                        xs: 12,
                        md: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por Nro de Factura: </Typography>
                        </Grid>
                        <Grid size={5}>
                            <Searchbox
                                fullWidth
                                size='small'
                                name='billingCode'
                                label='Punto de Venta'
                                onChange={handleFilterChange}
                                className={classes.searchbox}
                                value={filters?.billingCode || ""}
                            />
                        </Grid>
                        <Grid size={7}>
                            <Searchbox
                                fullWidth
                                size='small'
                                name='invoiceNumber'
                                label='Nro de Factura'
                                onChange={handleFilterChange}
                                className={classes.searchbox}
                                value={filters?.invoiceNumber || ""}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por cliente: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 5,
                                md: 5,
                                lg: 4
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='documentType'
                                onChange={handleFilterChange}
                                size='small'
                                label="Tipo de documento"
                                getOptionLabel={(option) => option?.label}
                                getOptionValue={(option) => option?.value}
                                value={filters?.documentType || ''}
                                values={FilterdocumentTypes}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 7,
                                md: 7,
                                lg: 8
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='documentNumber'
                                label='Documento'
                                onChange={handleFilterChange}
                                className={classes.searchbox}
                                value={filters?.documentNumber || ""}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {!franchiseSearch &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 6
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por fecha: </Typography>
                            </Grid>
                            <Grid size={6}>
                                <WrapperDatePicker
                                    filters={filters?.startDate}
                                    handleFilterChange={handleFilterChange}
                                    type="startDate"
                                />
                                
                            </Grid>
                            <Grid size={6}>
                                <WrapperDatePicker
                                    filters={filters?.endDate}
                                    handleFilterChange={handleFilterChange}
                                    type="endDate"
                                />
                            </Grid>
                        </Grid>
                    </Grid>}
                <Grid
                    size={{
                        xs: 12,
                        sm: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por estado: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <AutocompleteOrderStates
                                multiple
                                onChange={handleStateAutocompleteChange}
                                value={filters?.states}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {!franchiseSearch &&
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant='inherit' color='primary'> Filtrar por local: </Typography>
                            </Grid>
                            <Grid size={12}>
                                <AutocompleteBranches
                                    fullWidth
                                    multiple
                                    limitTags={4}
                                    business={business.isFranchise ? business.id : undefined}
                                    onChange={handleBranchAutocompleteChange}
                                    value={filters?.branchCodes}
                                    getOptionValue={(option) => option.code}
                                />
                            </Grid>
                        </Grid>
                    </Grid>}
                {
                    !franchiseSearch &&
                    <Grid size={12}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por medios de pago: </Typography>
                        </Grid>
                        <Grid size={6}>
                            <AutocompletePaymentMethods
                                multiple
                                name='paymentMethods'
                                filters={filters}
                                setFilters={setFilters}
                            />
                        </Grid>
                        <Grid size={6}>
                            <AutocompleteCards
                                multiple
                                name='CashTypeId'
                                value={filters?.CashTypeId}
                                onChange={handleAutocompleteCardsChange}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                }
                {!franchiseSearch &&
                    <Grid
                        size={{
                            xs: 6,
                            lg: 3
                        }}
                    >
                        <AutocompleteBolean
                            name="replaced"
                            onChange={handleAutoCompleteChange}
                            size="small"
                            label="Ventas Reemplazadas"
                            value={filters?.replaced?.toString() || ""}
                        />
                    </Grid>}
                {!franchiseSearch &&
                    <Grid
                        size={{
                            xs: 6,
                            lg: 3
                        }}
                    >
                        <AutocompleteBolean
                            name="isFromApp"
                            onChange={handleAutoCompleteChange}
                            size="small"
                            label="Inicializadas en la App"
                            value={filters?.isFromApp?.toString() || ""}
                        />
                    </Grid>}
                <Grid className={classes.rootFab} size="grow">
                    <Grid container spacing={1} justifyContent='flex-end'>
                        <Grid>
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={clearFilters}
                                startIcon={<FilterListIcon />}
                            >
                                Limpiar
                            </Button>
                        </Grid>
                        {franchiseSearch && <Grid>
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={handleSearch}
                                startIcon={<SearchIcon />}
                                disabled={!validateFilters()}
                            >
                                Buscar
                            </Button>
                        </Grid>}
                    </Grid>

                </Grid>
            </Grid>
        </Paper>
    );
}

export default OrderFilters;